import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../config';
import Avatar from '../components/Avatar';
import './RoamSharePage.css';

function isTokenExpired(token) {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (!payload.exp) return true;
    return Date.now() >= payload.exp * 1000;
  } catch {
    return true;
  }
}

const RoamSharePage = () => {
  const { isLoggedIn, accessToken } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [hasUsername, setHasUsername] = useState(true);
  const [posts, setPosts] = useState([]);
  const [redirected, setRedirected] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [likeStates, setLikeStates] = useState({});
  const [showLikedOnly, setShowLikedOnly] = useState(false);
  const [activeImageIndexes, setActiveImageIndexes] = useState({});
  const tagOptions = [
    'tourism','hidden gems','budget travel', 'adventure sports', 'water activities', 'wildlife safari', 'theme parks',
    'treks & hikes', 'wellness & retreats', 'beaches', 'mountains', 'historic monuments',
    'museums', 'scenic views', 'festivals', 'photographic spots', 'family travel',
    'solo travel', 'group travel', 'camping', 'art & architecture', 'wine & brewery tours',
    'shopping destination', 'weekend getaway', 'staycation','cultural immersion','local cuisine','nightlife','stargazing','desert safari'
  ];
  const [selectedTag, setSelectedTag] = useState('All');
  const [expandedPost, setExpandedPost] = useState(null);
  const [modalImageIndex, setModalImageIndex] = useState(0);
  const [postComments, setPostComments] = useState([]);
  const [commentOffset, setCommentOffset] = useState(0);
  const [hasMoreComments, setHasMoreComments] = useState(true);
  const [loadedReplies, setLoadedReplies] = useState({});
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [newComment, setNewComment] = useState('');
  const [commentSubmitting, setCommentSubmitting] = useState(false);
  const [replyingTo, setReplyingTo] = useState(null);
  const [replyText, setReplyText] = useState('');
  const [captionExpanded, setCaptionExpanded] = useState(false);
  const [myUsername, setMyUsername] = useState(null);
  const [myUserId, setMyUserId] = useState(null);
  const [openCommentMenuId, setOpenCommentMenuId] = useState(null);
  const [searchMode, setSearchMode] = useState('location'); // 'location' | 'user'
  const [userMatches, setUserMatches] = useState([]);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [followingUsernames, setFollowingUsernames] = useState([]);
  const [showReportModal, setShowReportModal] = useState(false);
  const [reportPostId, setReportPostId] = useState(null);
  const [reportCommentId, setReportCommentId] = useState(null);
  const [selectedReasons, setSelectedReasons] = useState([]);
  const [otherReason, setOtherReason] = useState('');
  const reportReasons = ['Spam', 'Inappropriate Content', 'Misinformation', 'Harassment', 'Other'];
  const [menuOpen, setMenuOpen] = useState(false);
  // === Infinite scroll pagination state ===
  const PAGE_SIZE = 20;                    
  const [cursor, setCursor] = useState(null); 
  const [isPaging, setIsPaging] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const sentinelRef = useRef(null);
  const seenIdsRef = useRef(new Set());     
  const likedSetRef = useRef(null);         
  const cursorRef = useRef(null);
  const pageCounterRef = useRef(0);  //delete later
useEffect(() => { cursorRef.current = cursor; }, [cursor]);

  // keep latest values for guards (avoid stale closures)
const isPagingRef = useRef(isPaging);
const hasMoreRef  = useRef(hasMore);
useEffect(() => { isPagingRef.current = isPaging; }, [isPaging]);
useEffect(() => { hasMoreRef.current  = hasMore;  }, [hasMore]);


  // Build feed URL with keyset cursor
const buildFeedUrl = (cur) => {
  const params = new URLSearchParams();
  params.set('limit', String(PAGE_SIZE));
  // Only send tag to backend when it's not "All"/"Followed"
  if (selectedTag && selectedTag !== 'All' && selectedTag.toLowerCase() !== 'followed') {
    params.set('tag', selectedTag);
  }
 if (cur && cur.time && cur.id != null) {
  const iso = new Date(cur.time).toISOString();
  params.set('cursor_time', iso);
  params.set('cursor_id', String(cur.id));
}

  return api.url(`/api/roam-share-posts?${params.toString()}`);
};

const computeCursorFrom = (arr) => {
  if (!arr || arr.length === 0) return null;
  const last = arr[arr.length - 1];
  return last?.created_at && last?.post_id
    ? { time: last.created_at, id: last.post_id }
    : null;
};

// One-time fetch of liked post IDs for this user
const ensureLikedSet = async () => {
  if (likedSetRef.current) return;
  try {
    const res = await fetch(api.url('/api/roam-share-posts/liked-posts'), {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (res.ok) {
      const ids = await res.json();
      likedSetRef.current = new Set(ids || []);
    } else {
      likedSetRef.current = new Set();
    }
  } catch {
    likedSetRef.current = new Set();
  }
};
// Fetch a page (initial or next)
const fetchPage = async (initial = false) => {
  // use refs so we never read stale values
  if (isPagingRef.current || !hasMoreRef.current) return;
  setIsPaging(true);
  isPagingRef.current = true; // keep the ref in sync immediately
  


  const url = buildFeedUrl(initial ? null : cursorRef.current);
 

  try {
    await ensureLikedSet();
    const res = await fetch(url);
    if (!res.ok) throw new Error(`feed fetch failed: ${res.status}`);

    const payload = await res.json();
console.log("=== ROAM SHARE RAW PAYLOAD START ===");
console.log("initial:", initial);
console.log("request url:", url);
console.log("payload:", payload);
console.log("=== ROAM SHARE RAW PAYLOAD END ===");
    // Support both shapes: legacy array OR cursor payload
    const pagePosts = Array.isArray(payload) ? payload : (payload.posts || []);
    const serverCursor = Array.isArray(payload) ? null : (payload.nextCursor || null);
    const serverHasMore = Array.isArray(payload) ? null : (payload.hasMore);

   console.log("pagePosts length:", pagePosts.length);
console.log(
  "pagePosts summary:",
  pagePosts.map((p) => ({
    post_id: p?.post_id,
    username: p?.username,
    post_type: p?.post_type,
    images: p?.images,
    video: p?.video,
    location: p?.location,
    created_at: p?.created_at,
    tags: p?.tags,
  }))
);
console.log("serverCursor:", serverCursor);
console.log("serverHasMore:", serverHasMore);

    // De-dup by post_id
    const uniques = [];
    for (const p of pagePosts) {
      if (!p || p.post_id == null) continue;
      if (!seenIdsRef.current.has(p.post_id)) {
        seenIdsRef.current.add(p.post_id);
        uniques.push(p);
      }
    }
    console.log("uniques length after dedupe:", uniques.length);
console.log(
  "uniques summary:",
  uniques.map((p) => ({
    post_id: p?.post_id,
    username: p?.username,
    post_type: p?.post_type,
    images: p?.images,
    video: p?.video,
    location: p?.location,
    created_at: p?.created_at,
    tags: p?.tags,
  }))
);
  // If we got no new items, stop trying to load more to avoid loops
if ((pagePosts.length === 0) || (uniques.length === 0 && !serverCursor)) {
  setHasMore(false);
  hasMoreRef.current = false;
  setIsPaging(false);
  isPagingRef.current = false;
  return; // <-- exit fetchPage early
}

    // Stamp page number onto the batch we just fetched     CHANGE LATER
const pageNo = pageCounterRef.current + 1; // 1, 2, 3...
const stamped = uniques.map(p => ({ ...p, __page: pageNo }));
setPosts(prev => [...prev, ...stamped]);
pageCounterRef.current = pageNo;


    // seed likeStates for new posts
    if (likedSetRef.current) {
      setLikeStates(prev => {
        const next = { ...prev };
        for (const p of uniques) {
          const liked = likedSetRef.current.has(p.post_id);
          next[p.post_id] = {
            liked,
            count: Number.isInteger(p.likes) ? p.likes : 0,
          };
        }
        return next;
      });
    }

   // Prefer server's cursor & hasMore if present; else compute locally
const nextCur = serverCursor || computeCursorFrom(pagePosts);

// If the cursor didn't advance AND we didn't get a full page, stop (prevents loops)
if ((nextCur == null || (cursorRef.current && nextCur?.id === cursorRef.current?.id && nextCur?.time === cursorRef.current?.time))
    && pagePosts.length < PAGE_SIZE) {
  setHasMore(false);
  hasMoreRef.current = false;
  return;
}

setCursor(nextCur);
cursorRef.current = nextCur; // keep the live value in sync

// Decide hasMore and sync the ref immediately (avoid stale during auto-prefetch)
const nextHasMore = (typeof serverHasMore === 'boolean')
  ? serverHasMore
  : (pagePosts.length === PAGE_SIZE);

setHasMore(nextHasMore);
hasMoreRef.current = nextHasMore;

    
  } catch (e) {
    
 } finally {
  // drop the paging flag in state AND the ref
  setIsPaging(false);
  isPagingRef.current = false;

 

}

};

  const handleCheckboxChange = (reason) => {
    if (selectedReasons.includes(reason)) {
      setSelectedReasons(selectedReasons.filter((r) => r !== reason));
    } else {
      setSelectedReasons([...selectedReasons, reason]);
    }
  };
const fetchComments = async (postId, offset = 0, append = false) => {
  if (!postId) return;

  setCommentsLoading(true);
  try {
    const res = await fetch(
      api.url(`/api/roam-share-posts/${postId}/comments?limit=5&offset=${offset}`),
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      }
    );

    if (!res.ok) {
      if (!append) setPostComments([]);
      return;
    }

    const data = await res.json();
    const incoming = Array.isArray(data) ? data : [];

    setPostComments((prev) => (append ? [...prev, ...incoming] : incoming));
    setHasMoreComments(incoming.length === 5);
    setCommentOffset(offset + incoming.length);
  } catch {
    if (!append) setPostComments([]);
  } finally {
    setCommentsLoading(false);
  }
};
const fetchReplies = async (commentId) => {
  if (!commentId || loadedReplies[commentId]) return;

  try {
    const res = await fetch(api.url(`/api/roam-share-posts/comments/${commentId}/replies`), {
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    if (!res.ok) return;

    const data = await res.json();
    setLoadedReplies((prev) => ({
      ...prev,
      [commentId]: Array.isArray(data) ? data : [],
    }));
  } catch {
    // no-op
  }
};
const openPost = (post) => {
  setExpandedPost(post);
  setModalImageIndex(0);
  setPostComments([]);
  setCommentOffset(0);
  setHasMoreComments(true);
  setLoadedReplies({});
  setNewComment('');
  setReplyingTo(null);
  setReplyText('');
  setCaptionExpanded(false);
  document.body.style.overflow = 'hidden';
  fetchComments(post.post_id);
};

const closePost = () => {
  setExpandedPost(null);
  setPostComments([]);
  setCommentOffset(0);
  setHasMoreComments(true);
  setLoadedReplies({});
  setNewComment('');
  setReplyingTo(null);
  setReplyText('');
setOpenCommentMenuId(null);
document.body.style.overflow = '';
};
  const handleAddComment = async () => {
  if (!expandedPost?.post_id || !newComment.trim() || commentSubmitting) return;

  setCommentSubmitting(true);

  try {
    const res = await fetch(api.url(`/api/roam-share-posts/${expandedPost.post_id}/comments`), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        comment_text: newComment.trim(),
      }),
    });

    if (!res.ok) return;

    setNewComment('');
    await fetchComments(expandedPost.post_id);

    setPosts((prev) =>
      prev.map((p) =>
        p.post_id === expandedPost.post_id
          ? { ...p, comments_count: (p.comments_count || 0) + 1 }
          : p
      )
    );

    setExpandedPost((prev) =>
      prev ? { ...prev, comments_count: (prev.comments_count || 0) + 1 } : prev
    );
  } catch {
  } finally {
    setCommentSubmitting(false);
  }
};

const handleAddReply = async (commentId) => {
  if (!expandedPost?.post_id || !commentId || !replyText.trim() || commentSubmitting) return;

  setCommentSubmitting(true);

  try {
    const res = await fetch(
      api.url(`/api/roam-share-posts/${expandedPost.post_id}/comments/${commentId}/reply`),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          comment_text: replyText.trim(),
        }),
      }
    );

    if (!res.ok) return;

    setReplyText('');
    setReplyingTo(null);
    await fetchComments(expandedPost.post_id);

    setPosts((prev) =>
      prev.map((p) =>
        p.post_id === expandedPost.post_id
          ? { ...p, comments_count: (p.comments_count || 0) + 1 }
          : p
      )
    );

    setExpandedPost((prev) =>
      prev ? { ...prev, comments_count: (prev.comments_count || 0) + 1 } : prev
    );
  } catch {
  } finally {
    setCommentSubmitting(false);
  }
};
const handleExpandedLike = async () => {
  if (!expandedPost?.post_id) return;

  const postId = expandedPost.post_id;
  const prevLiked = !!likeStates[postId]?.liked;
  const prevCount = likeStates[postId]?.count ?? expandedPost.likes ?? 0;

  const newLiked = !prevLiked;
  const newCount = newLiked ? prevCount + 1 : Math.max(prevCount - 1, 0);

  setLikeStates((prev) => ({
    ...prev,
    [postId]: {
      liked: newLiked,
      count: newCount,
    },
  }));

  setExpandedPost((prev) => (prev ? { ...prev, likes: newCount } : prev));

  setPosts((prev) =>
    prev.map((p) => (p.post_id === postId ? { ...p, likes: newCount } : p))
  );

  try {
    await fetch(api.url(`/api/roam-share-posts/like/${postId}`), {
      method: 'POST',
      headers: { Authorization: `Bearer ${accessToken}` },
    });
  } catch {
    setLikeStates((prev) => ({
      ...prev,
      [postId]: {
        liked: prevLiked,
        count: prevCount,
      },
    }));

    setExpandedPost((prev) => (prev ? { ...prev, likes: prevCount } : prev));

    setPosts((prev) =>
      prev.map((p) => (p.post_id === postId ? { ...p, likes: prevCount } : p))
    );
  }
};
  const handleDeleteComment = async (commentId) => {
  if (!commentId || !expandedPost?.post_id) return;

  const confirmDelete = window.confirm('Delete this comment?');
  if (!confirmDelete) return;

  try {
    const res = await fetch(api.url(`/api/roam-share-posts/comments/${commentId}`), {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!res.ok) {
      alert('Failed to delete comment.');
      return;
    }

    setOpenCommentMenuId(null);
    await fetchComments(expandedPost.post_id);

    const deletedComment = postComments.find((c) => c.comment_id === commentId);
    const deletedCount = deletedComment?.parent_comment_id
      ? 1
      : postComments.filter(
          (c) => c.comment_id === commentId || c.parent_comment_id === commentId
        ).length;

    setPosts((prev) =>
      prev.map((p) =>
        p.post_id === expandedPost.post_id
          ? { ...p, comments_count: Math.max((p.comments_count || 0) - deletedCount, 0) }
          : p
      )
    );

    setExpandedPost((prev) =>
      prev
        ? { ...prev, comments_count: Math.max((prev.comments_count || 0) - deletedCount, 0) }
        : prev
    );
  } catch {
    alert('Error deleting comment.');
  }
};
 useEffect(() => {
  if (selectedTag === 'Followed' && !followingUsernames) {
    return;
  }

  const query = (searchQuery || '').toLowerCase();
  let updatedPosts = [...posts];

  if (showLikedOnly) {
    updatedPosts = updatedPosts.filter(post => likeStates[post.post_id]?.liked);
  }

  if (selectedTag?.toLowerCase() === 'followed') {
    updatedPosts = updatedPosts.filter(post => {
      if (!post.username) return false;
      const postUser = post.username.toLowerCase();
      const isFollowed = Array.isArray(followingUsernames) && followingUsernames.includes(postUser);
      return isFollowed;
    });
  } else if (selectedTag !== 'All') {
    updatedPosts = updatedPosts.filter(
      post => Array.isArray(post.tags) && post.tags.includes(selectedTag)
    );
  }

  if (searchMode === 'location' && query) {
    updatedPosts = updatedPosts.filter(post =>
      post.username?.toLowerCase().includes(query) ||
      post.location?.toLowerCase().includes(query)
    );
  }

  setFilteredPosts(updatedPosts);
}, [searchQuery, posts, showLikedOnly, likeStates, selectedTag, searchMode, followingUsernames]);

useEffect(() => {
  if (selectedTag?.toLowerCase() !== 'followed') return;
  if (followingUsernames.length === 0) return;


  const query = (searchQuery || '').toLowerCase();
  let updatedPosts = [...posts];

  if (showLikedOnly) {
    updatedPosts = updatedPosts.filter(post => likeStates[post.post_id]?.liked);
  }

  updatedPosts = updatedPosts.filter(post => {
    const postUser = post.username?.toLowerCase();
    return followingUsernames.includes(postUser);
  });

  if (searchMode === 'location' && query) {
    updatedPosts = updatedPosts.filter(post =>
      post.username?.toLowerCase().includes(query) ||
      post.location?.toLowerCase().includes(query)
    );
  }

  setFilteredPosts(updatedPosts);
}, [searchQuery, posts, showLikedOnly, likeStates, selectedTag, searchMode, followingUsernames]);


useEffect(() => {
  // Reset pagination state whenever the tag changes
  seenIdsRef.current.clear();
  setPosts([]);
  setFilteredPosts([]);
  setCursor(null);
  cursorRef.current = null;
  setHasMore(true);
  hasMoreRef.current = true;
  pageCounterRef.current = 0; // keep if you still use __page
  // We do NOT fetch here — the next effect will drain all pages.
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [selectedTag]);

// Load everything in 20-item pages (no scroll needed)
useEffect(() => {
  let cancelled = false;

  const drainAll = async () => {
    try {
      // First page
      await fetchPage(true);

      // Keep fetching subsequent pages until the server says stop
      while (!cancelled && hasMoreRef.current) {
        await fetchPage(false);
        // Optional tiny delay to avoid hammering
        await new Promise(r => setTimeout(r, 50));
      }
    } catch  {
     
    }
  };

  drainAll();
  return () => { cancelled = true; };
  // Re-run whenever the selected tag changes
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [selectedTag]);

useEffect(() => {
  if (searchMode !== 'user') {
    setUserMatches([]);
    setShowUserDropdown(false);
    return;
  }

  const q = (searchQuery || '').trim();
  if (q.length < 2) {
    setUserMatches([]);
    setShowUserDropdown(false);
    return;
  }

  const ctrl = new AbortController();
  const t = setTimeout(async () => {
    try {
      const res = await fetch( api.url(`/api/roam-share-posts/user-search?q=${encodeURIComponent(q)}`),
        { headers: { Authorization: `Bearer ${accessToken}` }, signal: ctrl.signal }
      );
      if (!res.ok) {
        setUserMatches([]);
        setShowUserDropdown(false);
        return;
      }
      const data = await res.json();
      setUserMatches(Array.isArray(data) ? data : []);
      setShowUserDropdown(data && data.length > 0);
    } catch  {
      setUserMatches([]);
      setShowUserDropdown(false);
    }
  }, 200); // debounce

  return () => {
    clearTimeout(t);
    ctrl.abort();
  };
}, [searchMode, searchQuery, accessToken]);



  useEffect(() => {
    const init = async () => {
      if (!isLoggedIn || isTokenExpired(accessToken)) {
        setRedirected(true);
        navigate('/login', { state: { from: location.pathname } });
        return;
      }
  
      try {
        // ✅ Get user profile (username check)
        const res = await fetch(api.url('/api/roam-share-posts/my-profile'), {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
  
        if (res.ok) {
          const data = await res.json();
          setHasUsername(!!data.username);
          setMyUsername(data.username || null);
          setMyUserId(data.user_id || null);
         
          if (data.user_id) {
           
            const followingRes = await fetch( api.url(`/api/roam-share-posts/following/${data.user_id}`),{
              headers: {
                Authorization: `Bearer ${accessToken}`
              }
            });            
            if (followingRes.ok) {
              const followingData = await followingRes.json();
            
            
              if (Array.isArray(followingData) && followingData.length > 0) {
                const usernames = followingData
                  .filter(user => typeof user.username === 'string')
                  .map(user => user.username.toLowerCase());
                
                
                setFollowingUsernames(usernames);
              } else {
                
                setFollowingUsernames([]);
              }
            }
             else {
              
            }
          } else {
            
          }
        } else {
          setHasUsername(false);
        }
  
        setLoading(false);
      } catch {
        
        navigate('/profile');
      }
    };
  
    init();
  }, [isLoggedIn, accessToken, navigate, location.pathname]);

useEffect(() => {
  console.log("=== POSTS STATE UPDATED ===");
  console.log("posts length:", posts.length);
  console.log(
    "posts summary:",
    posts.map((p) => ({
      post_id: p?.post_id,
      username: p?.username,
      post_type: p?.post_type,
      images: p?.images,
      video: p?.video,
      location: p?.location,
      tags: p?.tags,
      created_at: p?.created_at,
    }))
  );
}, [posts]);
  useEffect(() => {
  console.log("=== FILTERED POSTS UPDATED ===");
  console.log("selectedTag:", selectedTag);
  console.log("showLikedOnly:", showLikedOnly);
  console.log("searchMode:", searchMode);
  console.log("searchQuery:", searchQuery);
  console.log("followingUsernames:", followingUsernames);
  console.log("filteredPosts length:", filteredPosts.length);
  console.log(
    "filteredPosts summary:",
    filteredPosts.map((p) => ({
      post_id: p?.post_id,
      username: p?.username,
      post_type: p?.post_type,
      images: p?.images,
      video: p?.video,
      location: p?.location,
      tags: p?.tags,
      created_at: p?.created_at,
    }))
  );
}, [filteredPosts, selectedTag, showLikedOnly, searchMode, searchQuery, followingUsernames]);
  useEffect(() => {
  const grid = document.querySelector('.roamshare-post-grid');
  if (grid) {
    const styles = window.getComputedStyle(grid);
    const rect = grid.getBoundingClientRect();

    console.log("🧱 GRID STYLES:", {
      childCount: grid.children.length,
      display: styles.display,
      visibility: styles.visibility,
      opacity: styles.opacity,
      position: styles.position,
      height: styles.height,
      width: styles.width,
      minHeight: styles.minHeight,
      overflow: styles.overflow,
      rectTop: rect.top,
      rectLeft: rect.left,
      rectWidth: rect.width,
      rectHeight: rect.height,
    });
  } else {
    console.log("❌ roamshare-post-grid not found in DOM");
  }
}, [filteredPosts]);
  useEffect(() => {
  const firstCard = document.querySelector('.roam-post-card');
  if (firstCard) {
    const styles = window.getComputedStyle(firstCard);
    const rect = firstCard.getBoundingClientRect();

    console.log("🧱 FIRST CARD STYLES:", {
      display: styles.display,
      visibility: styles.visibility,
      opacity: styles.opacity,
      position: styles.position,
      height: styles.height,
      width: styles.width,
      minHeight: styles.minHeight,
      overflow: styles.overflow,
      backgroundColor: styles.backgroundColor,
      color: styles.color,
      rectTop: rect.top,
      rectLeft: rect.left,
      rectWidth: rect.width,
      rectHeight: rect.height,
    });
  } else {
    console.log("❌ No .roam-post-card found in DOM");
  }
}, [filteredPosts]);
  useEffect(() => {
  const elements = document.elementsFromPoint(window.innerWidth / 2, 300);
  console.log(
    "🪟 ELEMENTS AT SCREEN POINT:",
    elements.map((el) => ({
      tag: el.tagName,
      className: el.className,
      id: el.id,
    }))
  );
}, [filteredPosts]);
  if (loading) return null;
  if (redirected || loading) return null;


  return (
    <div className="roamshare-page" >
      <div className="header">
            <div className="brand" onClick={() => navigate("/")}>
            <img src="/images/customroam-logo.png" alt="Logo" className="logo-img" />
            <span className="brand-text">CUSTOM ROAM</span>
             </div>
              {/* Hamburger menu button */}
              <button className="header-menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
                ☰
               </button>
             <div className={`nav-links ${menuOpen ? 'open' : ''}`}>
                    <span className="nav-link" onClick={() => navigate('/')}>Home</span>
                    <span className="nav-link" onClick={() => navigate('/roam-share')}>Roam Share</span>
                    <span className="nav-link" onClick={() => navigate('/my-itineraries')}>My Itineraries</span>
                    <span className="notification-icon" onClick={() => navigate('/notifications')}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                       height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                     className="bell-svg"
                    >
                        <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"></path>
                         <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                    </svg>
                 </span>
                    <span className="nav-link" onClick={() => navigate('/profile')}>Profile</span>
                </div>
            </div>
      <div className="roamshare-top-bar">
  <h1 className="roamshare-heading">Roam Share</h1>

  {/* Integrated Search Bar with Toggle */}
  <div className="searchbar">
    <div className="searchbar-left">
      <button
        type="button"
        className={`sb-toggle ${searchMode === 'location' ? 'active' : ''}`}
        onClick={() => {
          setSearchMode('location');
          setUserMatches([]);
          setShowUserDropdown(false);
          // keep searchQuery so it continues filtering posts by location
        }}
      >
        Locations
      </button>
      <button
        type="button"
        className={`sb-toggle ${searchMode === 'user' ? 'active' : ''}`}
        onClick={() => {
          setSearchMode('user');
          // keep searchQuery; it will drive username suggestions
        }}
      >
        Users
      </button>
    </div>

    <input
      className="searchbar-input"
      type="text"
      placeholder={searchMode === 'location' ? 'Search locations…' : 'Search users…'}
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      onFocus={() => {
        if (searchMode === 'user' && userMatches.length > 0) setShowUserDropdown(true);
      }}
      onBlur={() => setTimeout(() => setShowUserDropdown(false), 120)}
    />

    <button className="searchbar-go" type="button" aria-label="Search">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="8" cy="8" r="7" />
        <line x1="13.5" y1="13.5" x2="17" y2="17" />
      </svg>
    </button>

    {/* Dropdown (only in user mode) */}
    {searchMode === 'user' && showUserDropdown && userMatches.length > 0 && (
      <div className="searchbar-dropdown">
        {userMatches.map((u) => (
          <div
            key={u.username}
            className="searchbar-item"
            onMouseDown={(e) => e.preventDefault()} // don't close before click
            onClick={() => {
              setShowUserDropdown(false);
              setUserMatches([]);
              setSearchQuery('');
              navigate(`/u/${u.username}`);
            }}
          >
           <Avatar
  src={u.profile_picture || undefined}
  alt={u.username}
  size={28}
  className="searchbar-avatar"
/>

            <div className="searchbar-names">
              <span className="searchbar-username">@{u.username}</span>
              {u.bio && <span className="searchbar-bio">{u.bio}</span>}
            </div>
          </div>
        ))}
      </div>
    )}
  </div>

  <button className="interested-posts-button" onClick={() => setShowLikedOnly((prev) => !prev)}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="20" height="20" className="like-icon" style={{ marginRight: 6 }}>
      <path d="M32 2C18 2 6 14 6 28c0 7.7 5.5 15.3 12 21.6 4.8 4.5 10 8.4 14 12.4 4-4 9.2-8 14-12.4C52.5 43.3 58 35.7 58 28 58 14 46 2 32 2z" fill="#56ffc7" stroke="#008080" strokeWidth="1" />
      <path d="M32 16c-5-6.5-14-5.5-14 4 0 5 5 10 11 15l3 2.5 3-2.5c6-5 11-10 11-15 0-9.5-9-10.5-14-4z" fill="#e63946" stroke="#e63946" strokeWidth="4" />
    </svg>
    {showLikedOnly ? 'Show All Posts' : 'Liked Posts'}
  </button>
</div>

      
<div className="tag-filter-bar">
  <div className="tag-scroll-container">
  <span
  className={`tag-chip ${selectedTag === 'Followed' ? 'selected' : ''}`}
  onClick={() => {
    setSelectedTag('Followed');
    setSearchQuery('');
  }}
>
  Followed
</span>


<span
  className={`tag-chip ${selectedTag === 'All' ? 'selected' : ''}`}
  onClick={() => setSelectedTag('All')}
>
  All
</span>

{tagOptions.map((tag) => (
  <span
    key={tag}
    className={`tag-chip ${selectedTag === tag ? 'selected' : ''}`}
    onClick={() => setSelectedTag(tag)}
  >
    {tag}
  </span>
))}

  </div>
</div>

{!hasUsername ? (
  <div className="no-username-warning">
    <p>
      🚫 Please set up your username in{' '}
      <span
        onClick={() => navigate('/profile')}
        style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }}
      >
        Profile Page
      </span>{' '}
      to access Roam Share.
    </p>
  </div>
) : (
  <>
    <div className="roamshare-post-grid">
      {filteredPosts.length === 0 ? (
        <p>No posts found.</p>
      ) : (
       filteredPosts.map((post) => {
  console.log("RENDERING POST CARD:", {
    post_id: post?.post_id,
    username: post?.username,
    post_type: post?.post_type,
    images: post?.images,
    video: post?.video,
    location: post?.location,
    tags: post?.tags,
  });

  return (
            <div
  className={`roam-post-card ${post.__page === 1 ? 'page-one' : post.__page === 2 ? 'page-two' : ''}`}
  key={post.post_id}
  onClick={() => openPost(post)}
>

              <div className="roam-post-header">
                <div className="roam-post-header-left">
                  <Avatar
  src={post.profile_picture || undefined}
  alt={post.username || 'User'}
  size={40}
  className="roam-post-avatar"
/>

                  <div className="roam-post-user-info">
                    <span
                      className="roam-post-username clickable-username"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (
                          post.username &&
                          myUsername &&
                          post.username.toLowerCase() === myUsername.toLowerCase()
                        ) {
                          navigate('/profile');
                        } else {
                          navigate(`/u/${post.username}`);
                        }
                      }}
                    >
                      @{post.username}
                    </span>
                  </div>
                </div>

                <div
                  className="report-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    setReportPostId(post.post_id);
setReportCommentId(null);
setSelectedReasons([]);
setOtherReason('');
setShowReportModal(true);
                  }}
                  title="Report this post"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="teal"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    width="20"
                    height="20"
                  >
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                    <line x1="12" y1="9" x2="12" y2="13" />
                    <line x1="12" y1="17" x2="12.01" y2="17" />
                  </svg>
                </div>
              </div>

              {(() => {
                if (post.post_type === 'video') {
                  console.log("VIDEO POST BRANCH:", {
  post_id: post?.post_id,
  username: post?.username,
  video: post?.video,
});
  // post.video is already a full URL from the backend
  const videoUrl = post.video ? `${post.video}#t=0.5` : '';

  if (!videoUrl) return null;

  return (
    <div
      className="video-wrapper"
      onClick={(e) => e.stopPropagation()}
      onPointerDownCapture={(e) => e.stopPropagation()}
      onMouseDownCapture={(e) => e.stopPropagation()}
      onTouchStartCapture={(e) => e.stopPropagation()}
    >
      <video
  className="roam-post-video"
  controls
  playsInline
  preload="metadata"
  poster={videoUrl}
  onLoadedMetadata={(e) => {
    console.log("✅ VIDEO METADATA LOADED:", {
      post_id: post.post_id,
      username: post.username,
      src: videoUrl,
      videoWidth: e.target?.videoWidth,
      videoHeight: e.target?.videoHeight,
      duration: e.target?.duration,
    });
  }}
  onError={(e) => {
    console.log("❌ VIDEO FAILED:", {
      post_id: post.post_id,
      username: post.username,
      src: videoUrl,
      error: e.target?.error,
    });
  }}
  onClick={(e) => e.stopPropagation()}
  onPointerDownCapture={(e) => e.stopPropagation()}
  onMouseDownCapture={(e) => e.stopPropagation()}
  onTouchStartCapture={(e) => e.stopPropagation()}
>
  <source src={videoUrl} type="video/mp4" />
  Your browser does not support the video tag.
</video>
    </div>
  );
}
console.log("PHOTO POST BRANCH:", {
  post_id: post?.post_id,
  username: post?.username,
  rawImages: post?.images,
});

                const imagesArray = Array.isArray(post.images)
  ? post.images
  : (typeof post.images === 'string'
      ? (() => {
          try {
            return JSON.parse(post.images);
          } catch {
            return [];
          }
        })()
      : []);
console.log("PARSED IMAGES ARRAY:", {
  post_id: post?.post_id,
  username: post?.username,
  imagesArray,
  length: imagesArray.length,
});
const activeIndex = activeImageIndexes[post.post_id] || 0;
const showLeftArrow = imagesArray.length > 1;
const showRightArrow = imagesArray.length > 1;

                const goToNext = (postId, images) => {
                  setActiveImageIndexes((prevIndexes) => {
                    const currentIndex = prevIndexes[postId] || 0;
                    const nextIndex = (currentIndex + 1) % images.length;
                    return {
                      ...prevIndexes,
                      [postId]: nextIndex,
                    };
                  });
                };

                const goToPrev = (postId, images) => {
                  setActiveImageIndexes((prevIndexes) => {
                    const currentIndex = prevIndexes[postId] || 0;
                    const prevIndex = (currentIndex - 1 + images.length) % images.length;
                    return {
                      ...prevIndexes,
                      [postId]: prevIndex,
                    };
                  });
                };

                return (
                  <div className="carousel-wrapper">
                    {showLeftArrow && (
                      <button
                        className="carousel-arrow left"
                        onClick={(e) => {
                          e.stopPropagation();
                          goToPrev(post.post_id, imagesArray);
                        }}
                      >
                        ‹
                      </button>
                    )}

                <img
  key={`image-${post.post_id}-${activeIndex}`}
  src={imagesArray[activeIndex]}
  alt=""
  className="roam-post-image"
  onLoad={(e) => {
    const rect = e.target.getBoundingClientRect();
    const styles = window.getComputedStyle(e.target);

    console.log("✅ IMAGE LOADED:", {
      post_id: post.post_id,
      username: post.username,
      src: imagesArray[activeIndex],
      naturalWidth: e.target.naturalWidth,
      naturalHeight: e.target.naturalHeight,
      renderedWidth: rect.width,
      renderedHeight: rect.height,
      display: styles.display,
      visibility: styles.visibility,
      opacity: styles.opacity,
    });
  }}
  onError={(e) => {
    console.log("❌ IMAGE FAILED:", {
      post_id: post.post_id,
      username: post.username,
      src: imagesArray[activeIndex],
      naturalWidth: e.target?.naturalWidth,
      naturalHeight: e.target?.naturalHeight,
    });
  }}
/>
                    {showRightArrow && (
                      <button
                        className="carousel-arrow right"
                        onClick={(e) => {
                          e.stopPropagation();
                          goToNext(post.post_id, imagesArray);
                        }}
                      >
                        ›
                      </button>
                    )}
                  </div>
                );
              })()}

              <div className="roam-post-like-section">
  <div className="post-card-like-count">
    <div
      className={`like-icon-wrapper ${likeStates[post.post_id]?.liked ? 'liked' : ''}`}
      onClick={async (e) => {
                    e.stopPropagation();
                    const prev = likeStates[post.post_id];
                    const newLikeState = !prev?.liked;

                    // Optimistic UI
                    setLikeStates((prevState) => ({
                      ...prevState,
                      [post.post_id]: {
                        liked: newLikeState,
                        count: newLikeState ? prev.count + 1 : prev.count - 1,
                      },
                    }));

                    try {
                      await fetch(api.url(`/api/roam-share-posts/like/${post.post_id}`), {
                        method: 'POST',
                        headers: { Authorization: `Bearer ${accessToken}` },
                      });
                    } catch {
                      /* no-op */
                    }
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 64 64"
                    width="28"
                    height="28"
                    className="like-icon"
                  >
                    <path
                      d="M32 2C18 2 6 14 6 28c0 7.7 5.5 15.3 12 21.6 4.8 4.5 10 8.4 14 12.4 4-4 9.2-8 14-12.4C52.5 43.3 58 35.7 58 28 58 14 46 2 32 2z"
                      fill={likeStates[post.post_id]?.liked ? '#56ffc7' : 'none'}
                      stroke="#008080"
                      strokeWidth="4"
                    />
                    <path
                      d="M32 16c-5-6.5-14-5.5-14 4 0 5 5 10 11 15l3 2.5 3-2.5c6-5 11-10 11-15 0-9.5-9-10.5-14-4z"
                      fill={likeStates[post.post_id]?.liked ? '#e63946' : 'none'}
                      stroke="#e63946"
                      strokeWidth="3"
                    />
                  </svg>
    </div>

    <div className="like-count">{likeStates[post.post_id]?.count || 0}</div>
  </div>

  <div className="post-card-comment-count">
  <svg
    className="post-card-comment-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z" />
  </svg>
  <span>{post.comments_count || 0}</span>
</div>
              </div>

              <div className="roam-post-footer">
                <p className="roam-post-location">📍 {post.location}</p>
                <p className="roam-post-caption">{post.content}</p>
              </div>
            </div>
          );
        })
      )}
    </div>

    {/* Infinite scroll sentinel + status */}
    <div ref={sentinelRef} className="feed-sentinel" style={{ height: 1 }} />

    {isPaging && hasMore && (
      <div className="feed-loader" style={{ textAlign: 'center', padding: '16px' }}>
        Loading…
      </div>
    )}

    {!hasMore && posts.length > 0 && (
      <div className="feed-end" style={{ textAlign: 'center', padding: '16px', opacity: 0.7 }}>
        You’re all caught up.
      </div>
    )}
  </>
)}
    {/* 🔍 Expanded Post Modal */}
{expandedPost && (
  <div className="post-modal-overlay" onClick={closePost}>
    <div className="post-modal expanded-post-modal" onClick={(e) => e.stopPropagation()}>
      <button className="post-modal-close" onClick={closePost}>✕</button>

      <div className="expanded-post-left">
        {expandedPost.post_type === 'video' ? (
          <div className="modal-media expanded-media">
            <video
              className="modal-video"
              controls
              playsInline
              preload="metadata"
              src={expandedPost.video ? `${expandedPost.video}#t=0.5` : ''}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        ) : (
          (() => {
            const imgs = Array.isArray(expandedPost.images) ? expandedPost.images : [];
            const hasMany = imgs.length > 1;

            return (
              <div className="modal-media expanded-media">
                {hasMany && (
                  <button
                    className="carousel-arrow left"
                    onClick={(e) => {
                      e.stopPropagation();
                      setModalImageIndex(i => (i - 1 + imgs.length) % imgs.length);
                    }}
                  >
                    ‹
                  </button>
                )}

                <img className="modal-image" src={imgs[modalImageIndex]} alt="" />

                {hasMany && (
                  <button
                    className="carousel-arrow right"
                    onClick={(e) => {
                      e.stopPropagation();
                      setModalImageIndex(i => (i + 1) % imgs.length);
                    }}
                  >
                    ›
                  </button>
                )}
              </div>
            );
          })()
        )}
      </div>

      <div className="expanded-post-right">
        <div className="expanded-post-header">
  <Avatar
    src={expandedPost.profile_picture || undefined}
    alt={expandedPost.username || 'User'}
    size={42}
    className="roam-post-avatar"
  />

  <div className="expanded-post-main-info">
    <div className="expanded-caption-line">
     <span
  className="expanded-username clickable-username"
  onClick={() => {
    if (
      expandedPost.username &&
      myUsername &&
      expandedPost.username.toLowerCase() === myUsername.toLowerCase()
    ) {
      navigate('/profile');
    } else {
      navigate(`/u/${expandedPost.username}`);
    }
  }}
>
  @{expandedPost.username}
</span>
      {expandedPost.content && (
  <span
    className={`expanded-inline-caption ${captionExpanded ? 'expanded' : ''}`}
    onClick={() => setCaptionExpanded(true)}
  >
    : {expandedPost.content}
  </span>
)}
    </div>

    <div className="expanded-location">📍 {expandedPost.location}</div>

    <div className="expanded-post-actions">
     <span
  className={`expanded-like-action ${likeStates[expandedPost.post_id]?.liked ? 'liked' : ''}`}
  onClick={handleExpandedLike}
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="22"
    height="22"
    className="expanded-like-icon"
  >
    <path
      d="M32 2C18 2 6 14 6 28c0 7.7 5.5 15.3 12 21.6 4.8 4.5 10 8.4 14 12.4 4-4 9.2-8 14-12.4C52.5 43.3 58 35.7 58 28 58 14 46 2 32 2z"
      fill={likeStates[expandedPost.post_id]?.liked ? '#56ffc7' : 'none'}
      stroke="#008080"
      strokeWidth="4"
    />
    <path
      d="M32 16c-5-6.5-14-5.5-14 4 0 5 5 10 11 15l3 2.5 3-2.5c6-5 11-10 11-15 0-9.5-9-10.5-14-4z"
      fill={likeStates[expandedPost.post_id]?.liked ? '#e63946' : 'none'}
      stroke="#e63946"
      strokeWidth="3"
    />
  </svg>
  {likeStates[expandedPost.post_id]?.count ?? expandedPost.likes ?? 0}
</span>
      <span className="expanded-comment-count">
  <svg
    className="expanded-comment-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z" />
  </svg>
  {expandedPost.comments_count || 0}
</span>
    </div>
  </div>
</div>

        <div className="comments-section">
          <h3>Comments</h3>

          {commentsLoading ? (
            <p className="comments-empty">Loading comments...</p>
          ) : postComments.length === 0 ? (
            <p className="comments-empty">No comments yet. Be the first to comment.</p>
          ) : (
            postComments
              .filter((comment) => !comment.parent_comment_id)
              .map((comment) => {
                const replies = loadedReplies[comment.comment_id] || [];

                return (
                  <div key={comment.comment_id} className="comment-thread">
                    <div className="comment-item">
                      <Avatar
                        src={comment.profile_picture || undefined}
                        alt={comment.username || 'User'}
                        size={30}
                        className="comment-avatar"
                      />

                      <div className="comment-body">
                     <div className="comment-content-row">
  <div className="comment-text-wrap">
    <span
      className="comment-username clickable-username"
      onClick={() => {
        if (
          comment.username &&
          myUsername &&
          comment.username.toLowerCase() === myUsername.toLowerCase()
        ) {
          navigate('/profile');
        } else {
          navigate(`/u/${comment.username}`);
        }
      }}
    >
      @{comment.username}
    </span>
    <span className="comment-text">: {comment.comment_text}</span>
  </div>

  <div className="comment-menu-wrapper">
    <button
      className="comment-menu-button"
      onClick={(e) => {
        e.stopPropagation();
        setOpenCommentMenuId(
          openCommentMenuId === comment.comment_id ? null : comment.comment_id
        );
      }}
    >
      ⋯
    </button>

    {openCommentMenuId === comment.comment_id && (
      <div className="comment-menu-dropdown">
        <button
  onClick={() => {
    setReportCommentId(comment.comment_id);
    setReportPostId(null);
    setSelectedReasons([]);
    setOtherReason('');
    setOpenCommentMenuId(null);
    setShowReportModal(true);
  }}
>
  Report
</button>

        {String(comment.user_id) === String(myUserId) && (
          <button
            className="delete-comment-option"
            onClick={() => handleDeleteComment(comment.comment_id)}
          >
            Delete
          </button>
        )}
      </div>
    )}
  </div>
</div>

                        <button
                          className="reply-button"
                          onClick={() => {
                            setReplyingTo(comment.comment_id);
                            setReplyText('');
                            setOpenCommentMenuId(null);
                          }}
                        >
                          Reply
                        </button>
                            {comment.replies_count > 0 && !loadedReplies[comment.comment_id] && (
  <button
    className="reply-button"
    onClick={() => fetchReplies(comment.comment_id)}
  >
    View {comment.replies_count} replies
  </button>
)}
                      </div>
                    </div>

                    {replies.length > 0 && (
                      <div className="reply-list">
                        {replies.map((reply) => (
                          <div key={reply.comment_id} className="comment-item reply-item">
                            <Avatar
                              src={reply.profile_picture || undefined}
                              alt={reply.username || 'User'}
                              size={26}
                              className="comment-avatar"
                            />

                            <div className="comment-body">
  <div className="comment-content-row">
    <div className="comment-text-wrap">
      <span
        className="comment-username clickable-username"
        onClick={() => {
          if (
            reply.username &&
            myUsername &&
            reply.username.toLowerCase() === myUsername.toLowerCase()
          ) {
            navigate('/profile');
          } else {
            navigate(`/u/${reply.username}`);
          }
        }}
      >
        @{reply.username}
      </span>
      <span className="comment-text">: {reply.comment_text}</span>
    </div>

    <div className="comment-menu-wrapper">
      <button
        className="comment-menu-button"
        onClick={(e) => {
          e.stopPropagation();
          setOpenCommentMenuId(
            openCommentMenuId === reply.comment_id ? null : reply.comment_id
          );
        }}
      >
        ⋯
      </button>

      {openCommentMenuId === reply.comment_id && (
        <div className="comment-menu-dropdown">
<button
  onClick={() => {
    setReportCommentId(reply.comment_id);
    setReportPostId(null);
    setSelectedReasons([]);
    setOtherReason('');
    setOpenCommentMenuId(null);
    setShowReportModal(true);
  }}
>
  Report
</button>

          {String(reply.user_id) === String(myUserId) && (
            <button
              className="delete-comment-option"
              onClick={() => handleDeleteComment(reply.comment_id)}
            >
              Delete
            </button>
          )}
        </div>
      )}
    </div>
  </div>
</div>
                          </div>
                        ))}
                      </div>
                    )}

                    {replyingTo === comment.comment_id && (
                      <div className="reply-input-row">
                        <input
                          type="text"
                          value={replyText}
                          placeholder={`Reply to @${comment.username}`}
                          onChange={(e) => setReplyText(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') handleAddReply(comment.comment_id);
                          }}
                        />
                        <button
                          onClick={() => handleAddReply(comment.comment_id)}
                          disabled={!replyText.trim() || commentSubmitting}
                        >
                          Reply
                        </button>
                      </div>
                    )}
                  </div>
                );
                            })
          )}

          {hasMoreComments && !commentsLoading && postComments.length > 0 && (
            <button
              className="reply-button"
              onClick={() => fetchComments(expandedPost.post_id, commentOffset, true)}
            >
              View more comments
            </button>
          )}
        </div>

        <div className="comment-input-row">
          <input
            type="text"
            value={newComment}
            placeholder="what do you think?"
            onChange={(e) => setNewComment(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleAddComment();
            }}
          />
          <button
  className="comment-send-button"
  onClick={handleAddComment}
  disabled={!newComment.trim() || commentSubmitting}
  aria-label="Post comment"
>
  ➤
</button>
        </div>
      </div>
    </div>
  </div>
)}
{showReportModal && (
 <div
  className="modal-overlay"
  onClick={() => {
    setShowReportModal(false);
    setReportPostId(null);
    setReportCommentId(null);
  }}
>
    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
      <h3>{reportCommentId ? 'Report Comment' : 'Report Post'}</h3>
      <p>Select reason(s):</p>
<div className="report-reasons-checklist">
{reportReasons.filter((reason) => reason !== "Other").map((reason) => (
  <div key={reason} style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
    <input
      type="checkbox"
      id={reason}
      value={reason}
      checked={selectedReasons.includes(reason)}
      onChange={() => handleCheckboxChange(reason)}
      style={{
        marginRight: '10px',
        width: '18px',
        height: '18px',
        borderRadius: '50%',  // 🔵 makes it circular
        accentColor: 'teal'   // ✅ optional: use teal check
      }}
    />
    <label htmlFor={reason} style={{ fontSize: '16px' }}>{reason}</label>
  </div>
))}
{/* Other reason option */}
<div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
  <input
    type="checkbox"
    id="Other"
    value="Other"
    checked={selectedReasons.includes("Other")}
    onChange={() => handleCheckboxChange("Other")}
    style={{
      marginRight: '10px',
      width: '18px',
      height: '18px',
      borderRadius: '50%',
      accentColor: 'teal',
    }}
  />
  <label htmlFor="Other" style={{ fontSize: '16px' }}>Other</label>
</div>

{selectedReasons.includes("Other") && (
  <textarea
    className="other-reason-input"
    placeholder="Please specify your reason..."
    value={otherReason}
    onChange={(e) => setOtherReason(e.target.value)}
    rows={3}
    style={{ marginTop: "8px", width: "100%", resize: "vertical", fontSize: "14px" }}
  />
)}

</div>
      <div style={{ marginTop: '1rem' }}>
        <button
          onClick={async () => {
            if (selectedReasons.length === 0) {
              alert('Please select at least one reason.');
              return;
            } 
            if (selectedReasons.includes("Other") && !otherReason.trim()) {
              alert('Please specify your reason for selecting "Other".');
              return;
            }
                       
            try {
              const finalReason = selectedReasons
  .map((r) => (r === "Other" ? `Other: ${otherReason.trim()}` : r))
  .join(', ');

const res = await fetch(
  api.url(reportCommentId ? '/api/roam-share-posts/comments/report' : '/api/roam-share-posts/report'),
  {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(
      reportCommentId
        ? {
            comment_id: reportCommentId,
            reason: finalReason,
          }
        : {
            post_id: reportPostId,
            reason: finalReason,
          }
    ),
  }
);

              if (res.ok) {
                setShowReportModal(false);
                setSelectedReasons([]); 
                setReportPostId(null);
setReportCommentId(null);
alert('Report submitted. Thank you!');
              } else {
                alert('Failed to report the post.');
              }
            } catch {
              
              alert('Error submitting report.');
            }
          }}
          className="confirm-report-btn"
        >
          Submit
        </button>
       <button
  onClick={() => {
    setShowReportModal(false);
    setReportPostId(null);
    setReportCommentId(null);
  }}
  className="cancel-report-btn"
>
          Cancel
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
  
};

export default RoamSharePage;
